import { render, staticRenderFns } from "./appDropdownitem.vue?vue&type=template&id=33f58d7a&"
import script from "./appDropdownitem.vue?vue&type=script&lang=js&"
export * from "./appDropdownitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports